import json from "../json/geoLocation.json";

export default async () => JSON.parse(JSON.stringify(await json));
